/* tslint:disable */
/* eslint-disable */
export enum LiveBiddingMediaMagnificationMode {
  Disabled = 'disabled',
  Magnifier = 'magnifier',
  Window = 'window',
  Overlay = 'overlay'
}
